"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationBuffer = void 0;
class OperationBuffer {
    offset;
    operations;
    constructor() {
        this.offset = 0;
        this.operations = [];
    }
    /**
     * Returns the current revision in the buffer
     */
    get revision() {
        return this.offset + this.operations.length;
    }
    /**
     * Add new operation to the buffer
     */
    push(operation) {
        this.operations.push(operation);
    }
    /**
     * Get operation from buffer at given revision
     */
    get(revision) {
        return this.operations[revision - this.offset] ?? null;
    }
    /**
     * Get all operations after a certain revision/offset
     */
    slice(offset) {
        if (offset < this.offset) {
            throw new Error("Tried to get removed operations");
        }
        return this.operations.slice(offset - this.offset);
    }
    /**
     * Remove all operations from the buffer that happened before the specified revision
     *
     * @param revision the oldest revision that should be kept in the buffer
     */
    clear(revision) {
        const keepFromIndex = revision - this.offset;
        this.operations = this.operations.slice(keepFromIndex);
        this.offset += keepFromIndex;
    }
}
exports.OperationBuffer = OperationBuffer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3BlcmF0aW9uQnVmZmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL29wZXJhdGlvbmFsLXRyYW5zZm9ybXMvT3BlcmF0aW9uQnVmZmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQWEsZUFBZTtJQUMxQixNQUFNLENBQVM7SUFDZixVQUFVLENBQWtCO0lBRTVCO1FBQ0UsSUFBSSxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7UUFDaEIsSUFBSSxDQUFDLFVBQVUsR0FBRyxFQUFFLENBQUM7SUFDdkIsQ0FBQztJQUVEOztPQUVHO0lBQ0gsSUFBSSxRQUFRO1FBQ1YsT0FBTyxJQUFJLENBQUMsTUFBTSxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUMsTUFBTSxDQUFDO0lBQzlDLENBQUM7SUFFRDs7T0FFRztJQUNILElBQUksQ0FBQyxTQUF3QjtRQUMzQixJQUFJLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUNsQyxDQUFDO0lBRUQ7O09BRUc7SUFDSCxHQUFHLENBQUMsUUFBZ0I7UUFDbEIsT0FBTyxJQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksSUFBSSxDQUFDO0lBQ3pELENBQUM7SUFFRDs7T0FFRztJQUNILEtBQUssQ0FBQyxNQUFjO1FBQ2xCLElBQUksTUFBTSxHQUFHLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQztZQUN6QixNQUFNLElBQUksS0FBSyxDQUFDLGlDQUFpQyxDQUFDLENBQUM7UUFDckQsQ0FBQztRQUVELE9BQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsTUFBTSxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUNyRCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNILEtBQUssQ0FBQyxRQUFnQjtRQUNwQixNQUFNLGFBQWEsR0FBRyxRQUFRLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUM3QyxJQUFJLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLGFBQWEsQ0FBQyxDQUFDO1FBQ3ZELElBQUksQ0FBQyxNQUFNLElBQUksYUFBYSxDQUFDO0lBQy9CLENBQUM7Q0FDRjtBQW5ERCwwQ0FtREMifQ==